import api from "../index";
import {
	INotificationCount, INotificationCountTypeData,
	INotificationCountTypeParams,
	INotificationList,
	ISendNotificationData
} from "./interface";
import { IApiHandlerParams } from "@/api/interface";

export const $postNotificationList = (
	v: ISendNotificationData,
	handler?: IApiHandlerParams
): Promise<Array<INotificationList>> => api
	.post("notifications/pageable-list", v, { handler })
	.then(r => r || []);

export const $postNotificationCount = (): Promise<INotificationCount> => api
	.get("notifications/count");

export const $getNotificationCountType = (v?: INotificationCountTypeParams[]): Promise<Array<INotificationCountTypeData>> => api
	.get("notifications/topic-count", {
		request: { params: v },
		handler: { disableLoader: true }
	});

export const $putReadNotificationList = (id: number[], handler?: IApiHandlerParams): Promise<boolean> => api
	.put("notifications/read", { id }, { handler });

export const $getLastNotification = async (handler?: IApiHandlerParams): Promise<any[]> => {
	// return require('./mock/for-home-page.json').data

	return api
		.post("notifications/for-home-page", undefined, { handler })
		.then(r => r || []);
}